import { ChangeEvent, FC, ReactElement } from 'react'
import { Container } from './styles'

type UploadAvatarProps = {
  avatar?: string
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
}

const UploadAvatar: FC<UploadAvatarProps> = ({ avatar, onChange }): ReactElement => {
  return (
    <Container className='upload_avatar'>
      <div
        className='button'
        style={{ backgroundImage: `url(${avatar})` }}
      >
        Alterar foto
      </div>
      <input onChange={onChange} type='file' accept='image/jpeg, image/png, image/jpg' />
    </Container>
  )
}

export default UploadAvatar
